import { Config } from "../config";
import { DataService } from "../Services/dataService";
import { FirebaseService } from "../Services/firebaseService";

export class FacturePage {

    invoiceElement: HTMLElement = document.getElementById('invoicelist') as HTMLElement;
    loaderElement: HTMLElement = document.querySelector('.loader') as HTMLElement;

    firebaseService: FirebaseService;
    dataService: DataService;
    constructor() {
        this.firebaseService = new FirebaseService;
        this.dataService = new DataService;
        this.init()
    }

    async init() {
        this.loader(true);
        let token = await this.firebaseService.getUserIdToken();
        let user = await this.dataService.getUser(await this.firebaseService.getUserEmail(), token);
        if (user && user.invoices) {
            for (const [index, invoice] of user.invoices.entries()) {
                const div = document.createElement("div");

                const link = document.createElement("a");
                link.target = "_blank";
                link.style.marginLeft = "20px";
                link.href = `https://getInvoicePDF${Config.functionUrl}?i=${index}&t=${token}`;
                link.textContent = "Télécharger la facture";
                console.log(this.toDate(invoice.date));
                div.textContent = `Date : ${this.formatDateFR(this.toDate(invoice.date))} -  Numéro : ${invoice.number} - Montant : ${this.formatEuro(invoice.total)} `;
                div.appendChild(link);

                this.invoiceElement.appendChild(div);
            }
        }
        this.loader(false);
    }

    loader(show: boolean) {
        this.loaderElement.style.display = show ? 'block' : 'none';
    }

    toDate(ts: any): Date {
        if (ts?.toDate) {
            return ts.toDate(); // Firestore Timestamp
        }

        return new Date(ts._seconds * 1000); // objet brut
    }

    formatDateFR(date: Date): string {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    formatEuro(value: number): string {
        return new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "EUR",
        }).format(value);
    }
}